function currencyFormatter(currency, number){
    
    let countryCurrencyCode = ""

    switch(currency) {
        case "DKK":
            countryCurrencyCode = "da"
            break
        case "EUR":
            countryCurrencyCode = "de"
            break
        case "SEK":
            countryCurrencyCode = "sv"
            break
        case "NOK":
            countryCurrencyCode = "no"
            break
        default: 
        countryCurrencyCode = "da"
    }
    
    let currencyLabel = currency === "" ? currencyLabel = "DKK" : currencyLabel = currency
    //return new Intl.NumberFormat(`${countryCurrencyCode}`, { style: 'currency', currency: `${currencyLabel}` }).format(number)
    return `${currencyLabel} ${new Intl.NumberFormat(`${countryCurrencyCode}`, { minimumFractionDigits: 2, maximumFractionDigits: 2}).format(number)}`
}   

export default currencyFormatter


